import React from 'react';
import PropTypes from 'prop-types';

function Tab({
  children, isActive, className, ...props
}) {
  return (
    <li
      className={`Tab ${isActive ? ' Tab--active' : ''} ${className || ''}`}
      {...props}
    >
      {children}
    </li>
  );
}

Tab.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  isActive: PropTypes.bool,
};

export default Tab;
